import { Grid, Card, CardContent, Box, Typography, Skeleton } from '@mui/material'
import { People, Explore, Groups } from '@mui/icons-material'

interface StatsSummaryCardsProps {
  totalUsers?: number
  totalAdventures?: number
  totalGroups?: number
  isLoading?: boolean
}

export function StatsSummaryCards({
  totalUsers,
  totalAdventures,
  totalGroups,
  isLoading,
}: StatsSummaryCardsProps) {
  const cards = [
    {
      label: 'Total Users',
      value: totalUsers,
      icon: People,
      color: 'primary.main',
    },
    {
      label: 'Adventures',
      value: totalAdventures,
      icon: Explore,
      color: 'secondary.main',
    },
    {
      label: 'Total Groups',
      value: totalGroups,
      icon: Groups,
      color: 'success.main',
    },
  ]

  return (
    <Grid container spacing={3}>
      {cards.map(({ label, value, icon: Icon, color }) => (
        <Grid item xs={12} sm={4} key={label}>
          <Card sx={{ border: '2px solid', borderColor: color }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    {label}
                  </Typography>
                  {isLoading ? (
                    <Skeleton variant="text" width={80} height={40} />
                  ) : (
                    <Typography variant="h4" fontWeight="bold">
                      {value?.toLocaleString() ?? '—'}
                    </Typography>
                  )}
                </Box>
                <Icon sx={{ fontSize: 48, color, opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  )
}
